import { render } from "./MyLeaveEntitlements.vue?vue&type=template&id=751b481e"
import script from "./MyLeaveEntitlements.vue?vue&type=script&lang=js"
export * from "./MyLeaveEntitlements.vue?vue&type=script&lang=js"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__